<div class="stepper-header">
  <div class="steps-container">
    @for (step of steps(); track $index) {
      <div
        class="step"
        [class.active]="isStepActive($index)"
        [class.completed]="isStepCompleted($index)">

        <!-- Progress Line (hidden on first step) -->
        @if ($index > 0) {
          <div class="progress-line" [class.completed]="isStepCompleted($index - 1)"></div>
        }

        <!-- Step Box Content -->
        <div class="step-label-content">
          <!-- Step Icon/Number -->
          @if (isStepCompleted($index)) {
            <htx-icon class="step-icon" [icon]="'check_circle'"></htx-icon>
          } @else if (getStepIcon($index)) {
            <htx-icon class="step-icon-material" [icon]="getStepIcon($index)"></htx-icon>
          } @else {
            <span class="step-number">{{ $index + 1 }}</span>
          }

          <!-- Step Label Text -->
          <span class="step-label">{{ step.label }}</span>
        </div>
      </div>
    }
  </div>
</div>
